import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';

import { CopySourceAdapter, commonCopySourceAdapts } from './copysource.adapter';
import { CopyActivity } from 'app/model/pipeline/copy.activity';
import { NativeMongoDbCopySource } from 'app/model/pipeline/copysource/native-mongo-db.copysource';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
import { toCursorMethodClass, toCursorMethodObject } from 'app/model/adapters/linkedservices/cursor-method.util';
import { isLogicAppExpression, isExpressionObject } from '../../../../shared/utils/expression.util';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(NativeMongoDbCopySource),
    asynchronous: true,
    adapts: {
        ...commonCopySourceAdapts,
        batchSize: '*',
        filter: '*',
        cursorMethods: '*'
    }
})
export class NativeMongoDbCopySourceAdapter extends CopySourceAdapter<
    NativeMongoDbCopySource,
    Model.NativeMongoDbSource
> {
    protected override async _toResource(copySource: NativeMongoDbCopySource): Promise<Model.NativeMongoDbSource> {
        const result: Model.NativeMongoDbSource = this.getCommonCopySourceProperties(
            copySource,
            Metamodel.modelFor(NativeMongoDbCopySource).name
        );
        result.batchSize = ValueAdapter.toResource(copySource, NativeMongoDbCopySource.BATCH_SIZE);
        result.filter = ValueAdapter.toResource(copySource, NativeMongoDbCopySource.FILTER);
        const cursorMethodsValue =
            NativeMongoDbCopySource.CURSORMETHODS != null
                ? NativeMongoDbCopySource.CURSORMETHODS.templateValue(copySource)
                : undefined;
        result.cursorMethods =
            cursorMethodsValue != null
                ? ValueAdapter.toResource(copySource, NativeMongoDbCopySource.CURSORMETHODS)
                : toCursorMethodObject(copySource.cursorMethods);
        return result;
    }

    protected override async _toModel(
        resource: Model.NativeMongoDbSource,
        copyActivity: CopyActivity
    ): Promise<NativeMongoDbCopySource> {
        const result = this.createCopySourceWithCommonProperties(
            NativeMongoDbCopySource.MODEL,
            resource,
            copyActivity
        ) as NativeMongoDbCopySource;
        ValueAdapter.toModel(result, NativeMongoDbCopySource.BATCH_SIZE, resource.batchSize);
        ValueAdapter.toModel(result, NativeMongoDbCopySource.FILTER, resource.filter);
        if (
            resource.cursorMethods != null &&
            (isExpressionObject(resource.cursorMethods) || isLogicAppExpression(resource.cursorMethods))
        ) {
            ValueAdapter.toModel(result, NativeMongoDbCopySource.CURSORMETHODS, resource.cursorMethods);
        } else {
            result.cursorMethods = toCursorMethodClass(resource.cursorMethods, result);
        }
        return result;
    }
}
